import { STATISTIC_TYPE } from "./ReportingDashboard/elements.types"
//  This file defines types for UI components in a TypeScript project.
export enum UI_INPUT_TYPES {
  TEXT = "text",
  EMAIL = "email",
  PASSWORD = "password",
  NUMBER = "number",
  CHECKBOX = "checkbox",
  SELECT = "select",
}

/**
 * Represents SelectOption used in UI components.
 * It includes a value and a label for display.
 */
export interface SelectOption {
  value: string
  label: string
}

/**
 * Operator option for Statistic Type select components in Chart/Table settings.
 */
export interface OperatorOption {
  value: STATISTIC_TYPE
  label: string
}
// Define menu click event interface
export interface MenuClickEvent {
  key: string
}

export interface GroupingFlatOption extends SelectOption {
  parent?: string
}
export interface AntOptGroup {
  label: string
  options: SelectOption[]
}

// Define the tab item type
export interface TabItem {
  key: string
  label: string
  children: React.ReactNode
}
